import {
  faArrowLeft,
  faCloudUploadAlt,
  faCog,
  faPlus,
  faSearchPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import { messages } from "../../../localization/messages";
import { AppContext } from "../../domain/App/AppContext";
import Loader from "../Loader";
import ProcessComponent from "../ProcessComponent";

const SubmitButton = ({
  className = "buttonStyle",
  block,
  disabled,
  onClick,
  variant,
  text,
  type,
  processes,
  partyId,
  showLoader,
  transparent,
  children,
  readOnly,
  tooltipText,
  icon,
  isSubmit = true,
  ...props
}) => {
  const inProgress = useContext(AppContext).promiseInProgress;

  var showText = true;
  className += transparent ? " transparentButton" : "";

  switch (type) {
    case "save":
      text = text ? text : labels.saveButton;
      variant = variant ? variant : "primary";
      tooltipText = tooltipText
        ? tooltipText
        : messages.disabledSaveButtonTooltip;
      break;
    case "create":
      text = text ? text : labels.addButton;
      variant = variant ? variant : "success";
      isSubmit = showLoader;
      showText = showLoader;
      break;
    case "delete":
      text = text ? text : labels.deleteButton;
      variant = variant ? variant : "danger";
      isSubmit = showLoader;
      showText = showLoader;
      break;
    case "close":
      text = text ? text : labels.closeButton;
      variant = variant ? variant : "secondary";
      isSubmit = showLoader;
      break;
    case "back":
      text = text ? text : labels.backButton;
      variant = variant ? variant : "primary";
      isSubmit = false;
      showText = false;
      onClick = onClick ? onClick : () => window.history.back();
      break;
    case "search":
      text = text ? text : labels.search;
      variant = variant ? variant : "primary";
      isSubmit = showLoader;
      showText = showLoader;
      break;
    case "settings":
      text = text ? text : labels.settings;
      variant = variant ? variant : "light";
      isSubmit = false;
      showText = false;
      break;
    case "upload":
      text = text ? text : labels.upload;
      variant = variant ? variant : "primary";
      isSubmit = showLoader;
      break;
    case "link":
      text = text || text === "" ? text : labels.upload;
      variant = variant ? variant : "link";
      break;
    default:
      break;
  }

  const renderTooltip = props => <Tooltip {...props}>{tooltipText}</Tooltip>;

  const button = (
    <Button
      ref={props.buttonRef}
      style={disabled ? { pointerEvents: "none" } : {}}
      className={className}
      block={block}
      type={isSubmit ? "submit" : undefined}
      disabled={disabled || (isSubmit && inProgress) || readOnly}
      onClick={onClick}
      variant={variant}
      title={text}
      {...props}
    >
      {isSubmit && <Loader variant="light" size="sm" inline />}

      {type === "create" && !showLoader && <FontAwesomeIcon icon={faPlus} />}
      {type === "delete" && !showLoader && <FontAwesomeIcon icon={faTrash} />}
      {type === "back" && <FontAwesomeIcon icon={faArrowLeft} />}
      {type === "search" && !showLoader && (
        <FontAwesomeIcon icon={faSearchPlus} />
      )}
      {type === "settings" && <FontAwesomeIcon icon={faCog} />}
      {type === "upload" && !showLoader && (
        <FontAwesomeIcon icon={faCloudUploadAlt} />
      )}
      {icon ? icon : null}
      {showText && text}
      {children}
    </Button>
  );

  return (
    <ProcessComponent processes={processes} partyId={partyId}>
      {disabled && tooltipText ? (
        <OverlayTrigger
          overlay={renderTooltip}
          placement="auto"
          trigger={["hover", "focus"]}
        >
          <div className="disabled-button-div">{button}</div>
        </OverlayTrigger>
      ) : (
        button
      )}
    </ProcessComponent>
  );
};

SubmitButton.defaultProps = {
  block: false
};

export default SubmitButton;
